import { BsArrowBarDown } from 'react-icons/bs';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { FailedToGetData, H2, Loading, UsersSelector } from 'src/components/_commons';
import { setAlertResponse } from 'src/store';
import { sse } from '@/app-config';
import { sseEvents } from '@monorepo/helpers';
import { typeUser } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useGetCurrentUser, useGetIsMobile } from 'src/custom-hooks';
import { UsersCard } from './subcomponents/UsersCard';
import { userServices } from 'src/services';
import { UsersMasiveEdit } from './subcomponents/UsersMasiveEdit';
import { UsersNewUser } from './subcomponents/UsersNewUser';
import { UsersRolesModal } from './subcomponents/UsersRolesModal';

export const AdminsUsers = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [showMasiveEdit, setShowMasiveEdit] = useState(false);
    const [showNewUser, setShowNewUser] = useState(false);
    const [showRolesModal, setShowRolesModal] = useState(false);
    const [users, setUsers] = useState<typeUser[] | null>(null);
    const [usersToShow, setUsersToShow] = useState<typeUser[]>([]);
    const dispatch = useDispatch();
    const isMobile = useGetIsMobile();
    const user = useGetCurrentUser();

    useEffect(() => {
        userServices.GetAll().then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.users) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setUsers(response.data.users);
        })
    }, [dispatch, refreshCounter]);

    useEffect(() => {
        const handler = (e: MessageEvent) => {
            const data = JSON.parse(e.data);
            if (data.congregation !== user.congregation) {
                return;
            }
            setRefreshCounter(x => x + 1);
        };
        sse.addEventListener(sseEvents.userChange, handler);
        return () => {
            sse.removeEventListener(sseEvents.userChange, handler);
        };
    }, [user.congregation]);

    if (isLoading) {
        return <Loading mt={'80px'} />;
    }

    if (!users) {
        return <FailedToGetData />;
    }

    return (
        <>
        <H2 title={'USUARIOS'} />
        <div className={`${isMobile ? '' : 'd-flex justify-content-center'} mt-5 mb-3`}>
            <button className={`btn btn-general-blue btn-size12 ${isMobile ? 'd-block mx-auto mb-1' : 'me-2'}`}
                style={{ width: '350px', minHeight: '60px' }}
                onClick={() => setShowRolesModal(true)}
                disabled={showNewUser || showMasiveEdit}
            >
                VER ROLES <FaExternalLinkAlt size={isMobile ? '1rem' : '.9rem'} className={'mb-1'} />
            </button>
            <button className={`btn btn-general-blue btn-size12 ${isMobile ? 'd-block mx-auto mt-1' : 'ms-2'}`}
                style={{ width: '350px', minHeight: '60px' }}
                onClick={() => setShowNewUser(true)}
                disabled={showNewUser || showMasiveEdit}
            >
                NUEVO USUARIO <BsArrowBarDown size={isMobile ? '2rem' : '1.4rem'} className={'mb-1'} />
            </button>
            <button className={`btn btn-general-blue btn-size12 ${isMobile ? 'd-block mx-auto mt-1' : 'ms-2'}`}
                style={{ width: '350px', minHeight: '60px' }}
                onClick={() => setShowMasiveEdit(true)}
                disabled={showNewUser || showMasiveEdit}
            >
                EDICIÓN MASIVA <BsArrowBarDown size={isMobile ? '2rem' : '1.4rem'} className={'mb-1'} />
            </button>
        </div>
        {showRolesModal &&
            <UsersRolesModal
                closeModal={() => setShowRolesModal(false)}
                users={users}
            />
        }
        {showNewUser &&
            <UsersNewUser
                closeShowNewUser={() => {
                    setShowNewUser(false);
                }}
            />
        }
        {showMasiveEdit &&
            <UsersMasiveEdit
                closeSection={() => setShowMasiveEdit(false)}  // updated by socket
                users={users}
            />
        }
        {!showNewUser && !showMasiveEdit &&
            <div className={'mt-5'}>
                <UsersSelector
                    setUsersToShow={setUsersToShow}
                    users={users}
                    usersToShow={usersToShow}
                />
            </div>
        }
        {!showNewUser && !showMasiveEdit && usersToShow.map(user =>
            <UsersCard key={user.id}
                currentUser={user}
                users={users}
            />
        )}
        </>
    );
}
